import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./Loader";
import { getPendingRequests, subscribePendingRequests } from "../../services/requestTracker";

const MIN_VISIBLE_MS = 350; // long enough to read as intentional, not a flicker
const SETTLE_MS = 150; // wait for requests a page fires right after mounting
const MAX_VISIBLE_MS = 15000; // never block the page longer than this

// Shows the full-screen <Loader /> on every route change until the new page's
// initial API requests have finished.
const RouteLoader = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    const startedAt = Date.now();
    let settleTimer;

    const tryHide = () => {
      clearTimeout(settleTimer);
      if (getPendingRequests() > 0) return;
      const wait = Math.max(SETTLE_MS, MIN_VISIBLE_MS - (Date.now() - startedAt));
      settleTimer = setTimeout(() => {
        if (getPendingRequests() === 0) setVisible(false);
      }, wait);
    };

    const unsubscribe = subscribePendingRequests(tryHide);
    const maxTimer = setTimeout(() => setVisible(false), MAX_VISIBLE_MS);
    tryHide();

    return () => {
      unsubscribe();
      clearTimeout(settleTimer);
      clearTimeout(maxTimer);
    };
  }, [pathname]);

  // Once hidden, later requests (searches, polling) don't bring it back.
  return visible ? <Loader /> : null;
};

export default RouteLoader;
